<template>
  <menu-layout
    :title="$t('projects.title')"
    :subtitle="subtitle"
    :loading="loading"
    >
    <v-row>
      <v-card-text>
      <v-text-field id="filter_projects"
              v-model="filter" :label="$t('projects.filter')"></v-text-field>
      </v-card-text>
    </v-row>
    <v-row>
      <project-card
          style="cursor: pointer"
          v-for="project in filtered_projects"
          :key="project.id"
          :id="'project_'+project.id"
          :project="project"
          :recent="isRecentProject(project.id)"
          @click="select(project.id)"
      >
      </project-card>
      <project-add-card v-if="is_admin_somewhere">
      </project-add-card>
      <import-crop-dataset-card v-if="is_admin_somewhere">
      </import-crop-dataset-card>
    </v-row>
  </menu-layout>
</template>

<script>
import MenuLayout from "@/components/layout/MenuLayout";
import ProjectCard from "@/components/projects/ProjectCard";
import ProjectAddCard from "@/components/projects/ProjectAddCard";
import ImportCropDatasetCard from "@/components/projects/ImportCropDatasetCard";
import LoadProjectsMixin from "@/mixins/LoadProjectsMixin";
import CurrentUserMixin from "@/mixins/CurrentUserMixin";
import {
  getLastOpenedProjectIds,
  sortProjectsByLastOpened,
} from "@/utils/lastOpenedProjects";

export default {
  name: "Projects",
  data () {
    return {
      loading: true,
      filter: '',
      last_opened_ids: [],
    }
  },
  watch: {
    projects_loaded() {
      this.loading = false
    }
  },
  components: {
    ProjectCard,
    MenuLayout,
    ProjectAddCard,
    ImportCropDatasetCard,
  },
  methods: {
    refreshLastOpened() {
      this.last_opened_ids = getLastOpenedProjectIds().map(String);
    },
    isRecentProject(project_id) {
      return this.last_opened_ids.includes(String(project_id));
    },
    async check_2fa_setup_message() {
      let is2faMessageShown = sessionStorage.getItem('2fa_message_shown');
      if (is2faMessageShown) {
        return;
      } else {
        let response = await this.$api.user.user_2fa_enabled_profile();
        if (response && !response.authentication_enabled) {
          this.$store.dispatch('snackbars/add_persistent_snack', {
            message: this.$t('projects.2fa_not_enabled'),
            redirect: '/profile/authentication'
          });
          sessionStorage.setItem('2fa_message_shown', true);
        }
      }
    },
    select(project_id) {
      this.$store.commit('user/set_current_project_id', project_id);
      this.$router.push({ name: 'ProjectOverview' })
    },
  },
  computed: {
    subtitle() {
      if(this.projects.length > 1) {
        return this.$t('projects.subtitle_1');
      }
      else if(this.projects.length === 1) {
        return this.$t('projects.subtitle_2');
      }
      else {
        return this.$t('projects.subtitle_3');
      }
    },
    filtered_projects () {
      const list = this.filter === ''
        ? this.projects
        : this.projects.filter(project => String(project.name || '').includes(this.filter));
      // Depend on last_opened_ids so the list re-sorts after localStorage updates.
      void this.last_opened_ids;
      return sortProjectsByLastOpened(list);
    },
  },
  mounted() {
    this.refreshLastOpened();
    this.check_2fa_setup_message();
  },
  activated() {
    this.refreshLastOpened();
  },
  mixins: [LoadProjectsMixin, CurrentUserMixin]
}
</script>

<style scoped>

</style>